import { useState, useCallback } from "react";

const STORAGE_KEY = "portfolio.interest";

const readStoredInterest = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    // Storage can be blocked (private mode etc); the site just won't remember the choice.
    return null;
  }
};

/**
 * Hook for the visitor's chosen interest from the tailor modal ("game", "web", "mobile" or "all")
 * Persists the choice to localStorage so the modal only opens by itself on the first visit
 */
export const useInterest = () => {
  const [interest, setInterestState] = useState(readStoredInterest);

  const setInterest = useCallback((value) => {
    setInterestState(value);
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      // See above
    }
  }, []);

  return { interest, setInterest, hasChosen: interest !== null };
};
